import React from "react";

// Villa Alam brand mark — curving palm frond with feathery leaflets on BOTH
// sides of the midrib, plus two wavy water lines below. Matches the real
// brand logo on the welcome binder, keychain, and doormat.
const PalmMark = ({ size = 22, className = "" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        width={size}
        height={size}
        className={className}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {/* Central midrib — curving from lower-left to upper-right */}
        <path d="M2 42 C 14 34, 28 22, 52 8" />

        {/* Upper leaflets — fanning up from the midrib */}
        <path d="M8 38 C 6 32, 6 28, 8 24" />
        <path d="M14 34 C 10 28, 10 22, 14 18" />
        <path d="M22 28 C 18 22, 18 16, 22 12" />
        <path d="M30 22 C 28 16, 30 10, 34 8" />
        <path d="M38 16 C 38 12, 40 8, 44 7" />
        <path d="M46 11 C 46 8, 48 6, 51 7" />

        {/* Lower leaflets — fanning down from the midrib (mirror side) */}
        <path d="M8 38 C 10 42, 12 44, 14 46" />
        <path d="M14 34 C 17 38, 19 40, 22 42" />
        <path d="M22 28 C 25 32, 27 34, 30 36" />
        <path d="M30 22 C 33 26, 35 27, 38 28" />
        <path d="M38 16 C 41 19, 43 20, 46 21" />

        {/* Two wavy water lines below */}
        <path d="M4 54 Q 12 50, 20 54 T 36 54 T 58 54" />
        <path d="M4 60 Q 12 56, 20 60 T 36 60 T 58 60" />
    </svg>
);

export default PalmMark;
